/* eslint complexity: ["error", 5], max-params: ["error", 3], max-depth: ["error", 2], max-statements: ["error", 10] */
'use strict';

function processRequest(data) {
    var options = getOptionsSelectedPage.call(this, data) || {};
    var selectedPage = this.get('selectedPage');
    var selectedConfig = this.get(selectedPage);

    return $.extend(true, selectedConfig, options, this.opts);
}

function setRequestWaitingPage(data) {
    this.set('selectedPage', data.redirect || Odigeo.History.getPageNameFromFragment());
}

function getOptionsSelectedPage(data) {
    var functionFormat = {
        dpresults: getOptionsDpresults.call(this, data),
        dpresults_flights: getOptionsDpresults.call(this, data),
        dpresults_accommodation: getOptionsDpresults.call(this, data),
    };

    return functionFormat[this.get('selectedPage')];
}

function getOptionsDpresults(data) {
    var formattedData = {};

    if (data.type === 'oneWayTrip' || data.type === 'roundTrip') {
        formattedData.itinerary = getItinerary(data.searchSegments[0]);
        formattedData.dates = getDates(data, this.widget.options.UTCFormat);
        formattedData.travellers = getTravellers(data);
    }

    return formattedData;
}

function getItinerary(depSegment) {
    var maxLength = 26;
    var getValuesList = function(segment) {
        return Odigeo._.toArray(Odigeo._.pick(segment, ['city', 'name', 'iata']));
    };
    var sizedCombination = Odigeo.Utils.fitStringsCombination(maxLength, getValuesList(depSegment.departure), getValuesList(depSegment.destination));

    return {
        departure: sizedCombination[0],
        destination: sizedCombination[1],
    };
}

function getDates(data, formatDate) {
    var dates = {
        dateDeparture: null,
        dateDestination: null,
    };

    dates.dateDeparture = getUTCFormattedDate(data.searchSegments[0].dateStr, formatDate);
    if (data.type === 'roundTrip') {
        dates.dateDestination = getUTCFormattedDate(data.searchSegments[1].dateStr, formatDate);
    }

    return dates;
}

function getUTCFormattedDate(dateStr, formatDate) {
    return Odigeo.Utils.formatDate(Odigeo.Utils.parseDate(dateStr), formatDate, true);
}

function getTravellers(data) {
    return parseInt(data.numAdults, 10) + parseInt(data.numChildren, 10) + parseInt(data.numInfants, 10);
}

module.exports = Odigeo.Model.extend({
    defaults: {
        dpresults_accommodation: {
            id: 'dpresults',
            analytics: 1,
            type: null,
            itinerary: null,
            dates: null,
            travellers: null,
            adv: true,
        },
        dpresults_flights: {
            id: 'dpresults',
            analytics: 9,
            type: null,
            itinerary: null,
            dates: null,
            travellers: null,
            adv: true,
        },
        dpresults_accommodation_details: {
            id: 'accommodationdetails',
            analytics: 2,
        },
        booking: {
            id: 'dpresults',
            analytics: 8,
        },
        details: {
            id: 'details',
            analytics: 3,
        },
        passengersinfo: {
            id: 'dpresults',
            analytics: 3,
        },
        payment: {
            id: 'payment',
            analytics: 4,
        },
        confirmation: {
            id: 'confirmation',
            analytics: 5,
        },
        selectedPage: null,
    },

    initWaitingPage: function(data) {
        this.opts = Odigeo.Utils.parseOptions(this.widget.options);
        setRequestWaitingPage.call(this, data);

        return processRequest.call(this, data);
    },
});
